import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';

import styles from './Flag.less';
import LanguageToCountryMap from 'src/js/common/utils/language_to_country_map';

class Flag extends React.PureComponent {
  render() {
    const {language} = this.props;
    const country = LanguageToCountryMap[language] || {
      language: 'unknown',
      countryCode: '',
    };
    return (
      <div
        title={country.language}
        className={classNames({
          'flag-icon': true,
          [`flag-icon-${country.countryCode}`]: true,
          [styles.dlFlag]: true,
          [styles.dlFlagEmpty]: !country.countryCode,
        })}
      />
    );
  }
}

Flag.displayName = 'Flag';

Flag.propTypes = {
  language: PropTypes.string.isRequired,
};

export default Flag;
